import React from 'react';
import PaginatedTable from '@library/paginated-table';
import { TableFilters, useFiltering } from '@library/paginated-table/filtering';
import { useSorting } from '@library/paginated-table/sorting';
import OrvpReport from './orvp_report';
import parseQueryString from '@/helpers/parseQueryString';
import './styles';

function OrvpAdmin() {
  const { activeFilters, getActiveFilterValue, setActiveFilter, filterOptions, setFilterOptions } = useFiltering(
    [
      {
        name: 'Place',
        key: 'place_id',
        default: null,
        options: [{ name: 'All', id: null }],
      },
    ],
    parseQueryString()?.params || {}
  );

  const { activeSort, getSortLabel } = useSorting(
    [
      {
        name: 'ID',
        key: 'id',
      },
      {
        name: 'CPID',
        key: 'canonical_place_id',
      },
      {
        name: 'Place Name',
        key: 'place_name',
      },
      {
        name: 'City',
        key: 'city',
      },
      {
        name: 'Parking Allowed',
        key: 'parking_allowed',
      },
      {
        name: 'User Stayed',
        key: 'user_stayed',
      },
      {
        name: 'Policy Enforced',
        key: 'policy_enforced',
      },
      {
        name: 'Policy Confirmed',
        key: 'policy_confirmed',
      },
      {
        name: 'Created At',
        key: 'created_at',
      },
      {
        name: 'State',
        key: 'state',
      },
    ],
    '-created_at'
  );

  const onTableUpdated = (data) => {
    const updatedFilters = [...filterOptions];

    const aggCplaces = {};
    const cplaces = data.map((datum) => {
      return {
        name: datum.place.name,
        id: datum.place.id,
      };
    }).filter((cplace) => aggCplaces[cplace.id] ? false : aggCplaces[cplace.id] = true );

    updatedFilters[2].options = [{ name: 'All', id: null }];
    updatedFilters[2].options.push(...cplaces);

    setFilterOptions(updatedFilters);
  };

  const onRowAction = (action: string, options: { [key: string]: string }) => {
    if (action == 'filter') {
      setActiveFilter(options.key, options.option_id);
    }
  };

  return (
    <div className="editor__orvp_report_manager">
      <TableFilters
        filterOptions={filterOptions}
        getActiveFilterValue={getActiveFilterValue}
        setActiveFilter={setActiveFilter}
      />
      <PaginatedTable
        onDataChanged={onTableUpdated}
        onRowAction={onRowAction}
        dataFilters={activeFilters}
        dataSort={activeSort}
        Head={() => (
          <tr className="editor__orvp_report">
            <th>{getSortLabel('id')}</th>
            <th>{getSortLabel('canonical_place_id')}</th>
            <th>{getSortLabel('place_name')}</th>
            <th>{getSortLabel('city')}</th>
            <th>{getSortLabel('parking_allowed')}</th>
            <th>{getSortLabel('user_stayed')}</th>
            <th>{getSortLabel('policy_enforced')}</th>
            <th>{getSortLabel('policy_confirmed')}</th>
            <th>{getSortLabel('created_at')}</th>
            <th>{getSortLabel('state')}</th>
          </tr>
        )}
        Row={OrvpReport}
        url={'/orvp_reports.json'}
        limit={10}
      />
    </div>
  );
}

export default OrvpAdmin;
